import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	heading: {
		fontWeight: '600',
		color: theme.palette.primary.grey,
		width: '100%',
		padding: 0,
		textAlign: 'left',
		margin: '0 auto !important',
		marginBottom: '.8rem !important'
	},
	dropDownContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	formControl: {
		width: '100%'
	}
}));
